<template>
    <v-container fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar color="green" dark>
                        <v-toolbar-title>Reset password</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid">
                            <v-text-field prepend-icon="mdi-email" name="email" label="Email" type="email"
                                          v-model="email" :rules="emailRules" required data-cy="signInEmailField">
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text :to="{name: 'SignIn'}">Login</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1 white--text" :disabled="!valid" @click="onReset" data-cy="signInSubmitBtn">Reset</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'SignIn',
        data() {
            return {
                valid: false,
                email: '',
                password: '',
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid'
                ]
            };
        },
        methods: {
            onReset() {
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('resetPassword', this.email);
                }
            }
        }
    };
</script>

<style scoped>

</style>
